import React, { useContext, useState } from 'react'
import axios from 'axios'
import { observer } from 'mobx-react'
import { StoreContext } from '../../App'
import { Header, Button } from 'authflow-ui-engine'
import { IntroParagraph, ButtonText } from '../../../styles/generic.styles'
import {
  ContentContainerBottomFixed,
  Margined,
  MobileSpacerForContentContainerBottomFixed,
} from '../../../styles/layout.styles'
import { devLog } from '../../../methods/devLog'

interface IntroProps {
  nextStep: () => void
  phoneNumber: string
  sendOtpUrl: string
}

export const Intro = observer(
  ({ nextStep, phoneNumber, sendOtpUrl }: IntroProps) => {
    const store = useContext(StoreContext)
    const { theme } = store.InterfaceState
    const { ResumeFromEmailPage: trans } = store.TranslationsState.translations

    const [disabled, setDisabled] = useState(false)

    const sendOtp = async () => {
      setDisabled(true)

      try {
        await axios.post(sendOtpUrl, {}, { withCredentials: true })
      } catch (error) {
        devLog(error)
      }

      nextStep()
      setDisabled(false)
    }

    return (
      <>
        <Header
          {...theme.header}
          fontFamily={theme.globals.fontFamilyHeadline}
          margin="30px 0"
        >
          {trans.InfoPage.header}
        </Header>

        <IntroParagraph textAlign="center">
          {trans.InfoPage.description}
        </IntroParagraph>

        <Margined margin="0 0 30px" />

        <IntroParagraph textAlign="center">{phoneNumber}</IntroParagraph>

        <Margined margin="0 0 30px" />

        <ContentContainerBottomFixed border="none">
          <Button
            disabled={disabled}
            onClick={sendOtp}
            {...theme.button}
            width="190px"
            paddingMobile="14px 10px"
          >
            <ButtonText>{trans.InfoPage.proceed}</ButtonText>
          </Button>
        </ContentContainerBottomFixed>

        <MobileSpacerForContentContainerBottomFixed />
      </>
    )
  }
)
